// component
import Iconify from "../../components/Iconify";

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: "Inicio",
    path: "/dashboard/app",
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "Ingresos",
    path: "/dashboard/movimientos",
    icon: getIcon("eva:pantone-outline"),
  },
  {
    title: "Egresos",
    path: "/dashboard/egresos",
    icon: getIcon("eva:file-text-outline"),
  },
  {
    title: "Personas",
    path: "/dashboard/personas",
    icon: getIcon("mdi:people"),
  },
  {
    title: "Plazas",
    path: "/dashboard/plazas",
    icon: getIcon("mdi:file-table-box-multiple"),
  },
  {
    title: "Reportes",
    path: "/dashboard/reportes",
    icon: getIcon("eva:pie-chart-outline"),
  },

  //{
  //   title: "user",
  //   path: "/dashboard/user",
  //   icon: getIcon("eva:people-fill"),
  // },
];

export default sidebarConfig;
